export const onlyNumbers = (value = '') => value.replace(/\D+/g, '')
